var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import Auth from './Auth';

function handleErrors(response) {
  return new Promise((resolve, reject) => {
    if (!response.ok) {
      return reject(response);
    }
    // TODO handle better delete empty 204 responses
    if (response.status === 204) {
      return resolve();
    }
    return response.json().then(resolve).catch(reject);
  });
}

function getHeaders(isJSON = true) {
  const headers = {
    'browser-id': '551a8593cede18b4199eec32'
  };

  if (isJSON) {
    headers['Content-Type'] = 'application/json';
  }

  if (Auth.getToken()) {
    headers.Authorization = Auth.getAuthorizationHeader();
  }

  return headers;
}

class Fetch {

  static getJSON(url, { headers = {} } = {}) {
    return fetch(url, {
      headers: _extends({}, getHeaders(), headers)
    }).then(handleErrors);
  }

  static get(url, { headers = {} } = {}) {
    return fetch(url, {
      headers: _extends({}, getHeaders(false), headers)
    }).then(handleErrors);
  }

  static postJSON(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'POST',
      headers: _extends({}, getHeaders(), headers),
      body: JSON.stringify(data)
    }).then(handleErrors);
  }

  static post(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'POST',
      headers: _extends({}, getHeaders(false), headers),
      body: data
    }).then(handleErrors);
  }

  static putJSON(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'PUT',
      headers: _extends({}, getHeaders(), headers),
      body: JSON.stringify(data)
    }).then(handleErrors);
  }

  static put(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'PUT',
      headers: _extends({}, getHeaders(false), headers),
      body: data
    }).then(handleErrors);
  }

  static patchJSON(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'PATCH',
      headers: _extends({}, getHeaders(), headers),
      body: JSON.stringify(data)
    }).then(handleErrors);
  }

  static patch(url, data, { headers = {} } = {}) {
    return fetch(url, {
      method: 'PATCH',
      headers: _extends({}, getHeaders(false), headers),
      body: data
    }).then(handleErrors);
  }

  static deleteJSON(url, { headers = {} } = {}) {
    return fetch(url, {
      method: 'DELETE',
      headers: _extends({}, getHeaders(), headers)
    }).then(handleErrors);
  }

  static delete(url, { headers = {} } = {}) {
    return fetch(url, {
      method: 'DELETE',
      headers: _extends({}, getHeaders(false), headers)
    }).then(handleErrors);
  }
}

export default Fetch;